<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Expand">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Expand" clip-path="url(#clip-Expand)">
            <rect width="36" height="36" fill="rgba(81,91,96,0)"/>
            <g id="Group_13308" data-name="Group 13308" transform="translate(6 6)">
                <path id="Path_33" data-name="Path 33" d="M0,36H36V0H0Z" transform="translate(-6 -6)" fill="#7b8387" opacity="0"/>
                <path id="Path_34" data-name="Path 34" d="M7.41,8,12,12.58,16.59,8,18,9.41l-6,6-6-6Z" transform="translate(0 0.59)" class="svg-secondary-color"/>
                <g id="Group_13362" data-name="Group 13362" transform="translate(-6 -6)">
                    <g id="Ellipse_975" data-name="Ellipse 975" fill="none" class="svg-stroke-block-color" stroke-miterlimit="10" stroke-width="1">
                        <circle cx="18" cy="18" r="18" stroke="none"/>
                        <circle cx="18" cy="18" r="17.5" fill="none"/>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "ExpandIcon",
    props: {
        width: {
            type: Number,
            default: 36,
        },
        height: {
            type: Number,
            default: 36
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/ExpandIcon.vue